import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { FrontChatService } from '../frontchat.service';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})

export class AuthService extends BaseService {
  public user$ = new BehaviorSubject<boolean | object>(false);
  public showingMessage$ = new BehaviorSubject<boolean>(false);
  ls = localStorage;

  constructor(http: HttpClient, private router: Router, private frontChat: FrontChatService) {
    super(http);
  }

  public login(data: any) {
    return this.http.post(`${this.urlApi}/user/login`, data).toPromise();
  }

  isTokenValid() {
    const tk = this.ls.getItem('user');

    if (tk) {
      const token = JSON.parse(tk);
      const dateNow = (new Date()).getTime() / 1000;
      const tkDate = new Date(token.expiresIn).getTime() / 1000;
      return (tkDate > dateNow)
        ? true
        : this.removeTokenExpired()
    }
    return false;
  }

  logout(): void {
    localStorage.clear();
    this.frontChat.shutdown();
    this.user$.next(false);

    window.location.reload();
  }


  removeTokenExpired() {
    localStorage.clear();
    return false;
  }

  setUserInfo(data: boolean | object) { return this.user$.next(data); }

  setMessageStatus(status: boolean) { return this.showingMessage$.next(status); }

  redirectToLogin() {
    return this.router.navigate(['/login']);
  }
}
